import { render, staticRenderFns } from "./NCSCompra.vue?vue&type=template&id=2473f0e4&scoped=true"
import script from "./NCSCompra.vue?vue&type=script&lang=js"
export * from "./NCSCompra.vue?vue&type=script&lang=js"
import style0 from "./NCSCompra.vue?vue&type=style&index=0&id=2473f0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473f0e4",
  null
  
)

export default component.exports